import { ElementType, PropsWithChildren, ReactElement } from 'react';
import { SxProps, TablePagination } from '@mui/material';
import { tablePagination } from './deprecated/PanelTable.styles';

export interface Pagination {
  currentPage: number;
  pageOffset: number;
  rowsPerPage: number;
}

interface ITable {
  sx?: SxProps;
  count: number;
  page: number;
  rowsPerPage: number;
  component?: ElementType;
  onPageChange: (event: any, data: any) => void;
  onRowsPerPageChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  actionButton?: ReactElement;
  rowsPerPageOptions?: number[];
}

export const LioTablePagination = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  sx,
  component = 'td',
  rowsPerPageOptions = [10, 25, 50, 100],
}: PropsWithChildren<ITable>) => {
  const styles = sx ? { ...tablePagination, ...sx } : tablePagination;

  return (
    <TablePagination
      aria-label='Pagination'
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      rowsPerPageOptions={rowsPerPageOptions}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      sx={styles as SxProps}
      component={component}
      showFirstButton={true}
      showLastButton={true}
    />
  );
};
